import { Outlet } from 'react-router-dom';

import { useAuthentication } from '@zenbusiness/application-commons-authentication';
import { ClickstreamScene } from '@zenbusiness/application-commons-clickstream';
import { CartProvider } from '@zenbusiness/application-commons-ecommerce';
import { usePriceList } from '@zenbusiness/application-commons-pricelist';

import useFlowConfig from '#client/hooks/flow/useFlowConfig';
import useFlowState from '#client/hooks/flow/useFlowState';

import ApplicationReadyGate from './ApplicationReadyGate';
import { useNotification } from './NotificationManager';

export default function EcommerceProviders({ children }) {
  const {
    clickStreamProps,
    id: flowId,
    priceListUuid,
    version: flowVersion,
    disableCartCreation
  } = useFlowConfig();
  const { priceListName } = usePriceList();
  const { cartUuid, orderUuid } = useFlowState();
  const { authenticated } = useAuthentication();
  // TODO: Once we resolve having to identify via the provider, this will be deleted (jh)
  //       See also: https://counsl.atlassian.net/browse/FUN-4892
  // const { trackingParams } = useFlowState();
  const { onError } = useNotification();

  const cartProviderProps = {
    anonymous: !authenticated, // Anonymous carts if not authenticated
    autoLoad: !orderUuid, // Load cart if no order has yet been placed
    disableCreation: disableCartCreation,
    cartUuid,
    priceListUuid,
    tracking: {
      flowName: flowId,
      flowVersion: String(flowVersion),
      purchaseSource: 'shop'
    },
    onError
  };

  const clickstreamSceneProps = {
    flowPriceListName: priceListName,
    flowPriceListUuid: priceListUuid,
    ...clickStreamProps
  };

  return (
    <ClickstreamScene {...clickstreamSceneProps}>
      <CartProvider {...cartProviderProps}>
        <ApplicationReadyGate>{children || <Outlet />}</ApplicationReadyGate>
      </CartProvider>
    </ClickstreamScene>
  );
}
